import { EditorTarget } from '../../app/canvas/EditorSession';
import { Physical } from '../../app/canvas/entities/Physical';
import { OverlayPointerTarget } from '../../app/canvas/overlay/Overlay';
import { Component } from '../../concepts/objects';
import { Modifiers } from './Modifiers';

export abstract class AbstractInput {

    public readonly modifiers: Modifiers;
    public readonly targetPhysical?: Physical;
    public readonly targetOverlay?: OverlayPointerTarget;

    protected constructor(modifiers: Modifiers, [top]: EditorTarget[]) {
        this.modifiers = modifiers;
        if (top) {
            if (top instanceof Component) {
                this.targetPhysical = top;
            }
            else {
                this.targetOverlay = top;
            }
        }
    }
}
